import { render, staticRenderFns } from "./Pie.vue?vue&type=template&id=f48e83ca&scoped=true&"
import script from "./Pie.vue?vue&type=script&lang=ts&"
export * from "./Pie.vue?vue&type=script&lang=ts&"
import style0 from "./Pie.vue?vue&type=style&index=0&id=f48e83ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48e83ca",
  null
  
)

export default component.exports